import styled from '@emotion/styled';

export const TimerDisplay = styled.div`
    display: flex;
    align-items: center;
    color: #E21216;
    font-size: 14px;

    @media (max-width: 710px) {
        font-size: 12px;
    }
`;
